// Словарь интерфейса (Русский). Ключ = либо смысловой (nav.*, col.*), либо английский оригинал.
const ru = {
  // Выгрузка набора данных
  "Export dataset": "Выгрузить датасет",
  "Export dataset hint": "Будет подготовлен архив с разметкой: JSONL с сегментами, CSV-таблицы и сводка. Подготовка идёт на сервере, это может занять время.",
  "Export format": "Что выгрузить",
  "Export format full": "Полный набор: JSONL, CSV по сегментам, сводка",
  "Export format markup": "Таблица audio,text — как во входном файле разметки (этот датасет)",
  "Export format markup hint": "Одна строка на файл, пути к файлам — как в исходной таблице. Текст берётся с самого позднего пройденного этапа: суперпроверка, проверка, разметка.",
  "Export layer": "Какой текст",
  "Export layer verbatim": "Дословный (L1)",
  "Export layer normalized": "Нормализованный (L2)",
  "Include audio files": "Включить аудиофайлы",
  "Include audio warning": "С аудио архив будет большим (несколько ГБ) и готовится дольше.",
  "Prepare export": "Подготовить",
  "Export ready": "Выгрузка готова",
  "Export failed": "Не удалось подготовить выгрузку",
  "Nothing to export": "Нечего выгружать: нет сданной разметки",
  "Queued": "В очереди",
  "Collecting records": "Собираю записи",
  "Writing files": "Пишу файлы",
  "Packing archive": "Упаковываю архив",
  "records": "записей",
  "segments": "сегментов",

  // подписи таблиц (MUIDataTable)
  "Rows per page:": "Строк на странице:",
  "of": "из",
  "Next Page": "Следующая страница",
  "Previous Page": "Предыдущая страница",
  "No records": "Нет записей",
  "Sorry, no matching records found": "Ничего не найдено",
  "View Columns": "Столбцы",
  "Sort": "Сортировка",
  "Jump to page:": "Перейти на страницу:",
  "Download CSV": "Скачать CSV",
  "Print": "Печать",
  "FILTERS": "ФИЛЬТРЫ",
  "RESET": "СБРОС",
  "Show Columns": "Показать столбцы",
  "row(s) selected": "строк выбрано",
  "Delete Selected Rows": "Удалить выбранные строки",
  landlingPageLabel: "CSI Annotator",
  enterEmailId: "Введите email*",
  enterPassword: "Введите пароль*",
  forgotPassword: "Забыли пароль?",
  newPassword: "Введите новый пароль*",
  currentPassword: "Введите текущий пароль*",
  "label.appInfo": "CSI Annotator — платформа для разметки и транскрибирования аудио.",
  "button.clearAll": "Очистить всё",
  "button.clear": "Очистить",
  "button.Filter": "Фильтр",
  "button.Apply": "Применить",
  "label.filter.status": "Статус",
  "label.filter.byAnnotator": "Фильтр по аннотаторам",
  "label.filter.column": "Выбрать столбцы",
  "button.cancel": "Отмена",
  "button.addNewWorkspace": "Добавить рабочее пространство",
  "button.inviteNewMEmbersToOrganization": "Пригласить участников в организацию",
  "button.notes": "Заметки",
  "button.draft": "Черновик",
  "button.next": "Далее",
  "button.skip": "Пропустить",
  "button.submit": "Отправить",
  "label.workspaces": "Рабочие пространства",
  "label.members": "Участники",
  "label.annotators": "Аннотаторы",
  "label.reviewers": "Проверяющие",
  "label.invites": "Приглашения",
  "label.settings": "Настройки",
  "label.logs": "Журнал",
  "label.tasks": "Задачи",
  "label.annotationTasks": "Задачи разметки",
  "label.reviewTasks": "Задачи проверки",
  "label.allTask ": "Все задачи",
  "label.reports": "Отчёты",
  "label.projectanalytics": "Аналитика проекта",
  "label.projects": "Проекты",
  "label.managers": "Менеджеры",
  "label.backToPreviousPage": "Назад",
  "label.showProjectSettings": "Настройки проекта",
  "label.backToProject": "Назад к проекту",
  "alert.notes": "Не добавляйте заметки, если собираетесь пропустить задачу!",
  "label.datasets": "Датасеты",
  "button.downloadDataset": "Скачать датасет",
  "button.uploadData": "Загрузить данные",
  "link.Createanaccount": "Создать аккаунт",
  "tooltip.AnalyticsType": " Вариативность графика в зависимости от числа выбранных диапазонов времени. В режиме «Individual» показывается один диапазон, в «Comparison» — два для сравнения. По умолчанию «Individual».",
  "tooltip.ProjectType": " Тип проекта, по которому строится график. По умолчанию «ContextualTranslationEditing».",
  "tooltip.Baseperiod": "Диапазон времени для первого графика. Кумулятивный, месячный или недельный. По умолчанию «Кумулятивный».",
  "tooltip.ComparisonPeriod": "Диапазон времени для второго графика (в режиме сравнения). Кумулятивный, месячный или недельный.",
  "label.recentTasks.annotation": "Разметка",
  "label.recentTasks.review": "Проверки",
  "button.deleteDataItems": "Удалить элемент данных",
  "label.Rate this translation": "Оцените перевод",
  "button.Suggest an edit": "Предложить правку",
  "button.Your feedback": "Ваш отзыв поможет улучшить продукт",
  "label.analytics": "Аналитика",

  "nav.organization": "Организация",
  "nav.admin": "Админ",
  "menu.myProfile": "Мой профиль",
  "menu.myProgress": "Мой прогресс",
  "menu.changePassword": "Сменить пароль",
  "menu.logout": "Выйти",
  "menu.signedInAs": "Вы вошли как",
  "tooltip.notifications": "Уведомления",
  "tooltip.userOptions": "Меню пользователя",

  "login.title": "Вход в CSI Annotator",
  "login.button": "Войти",

  "common.view": "Открыть",
  "common.search": "Поиск",
  "common.actions": "Действия",
  "common.action": "Действие",
  "common.status": "Статус",
  "common.name": "Название",
  "common.id": "ID",
  "common.noRecords": "Нет записей",
  "common.rowsPerPage": "Строк на странице:",
  "common.jumpToPage": "Перейти на страницу:",
  "common.createdBy": "Создал",
  "view.list": "Список",
  "view.card": "Карточки",
  "view.label": "Вид:",

  "col.projectId": "ID проекта",
  "col.projectTitle": "Название проекта",
  "col.projectType": "Тип проекта",
  "col.projectStage": "Схема работы",
  "col.targetLanguage": "Язык",
  "col.workspaceId": "ID пространства",
  "col.domain": "Домен",
  "col.scenario": "Сценарий",
  "col.audioDuration": "Длительность аудио",
  "col.referenceRawTranscript": "Эталонная транскрипция",
  "col.annotatorEmail": "Email аннотатора",

  "proj.addNewAnnotationProject": "Новый проект разметки",
  "proj.pullNewBatch": "Взять пачку задач",
  "proj.pullSize": "Размер пачки",
  "proj.deallocate": "Освободить задачи",
  "proj.startLabelling": "Начать разметку",
  "proj.startReviewing": "Начать проверку",
  "proj.annotate": "Разметить",
  "proj.review": "Проверить",
  "proj.unassignedAnnotationTasks": "Незанятые задачи разметки",
  "proj.unassignedReviewTasks": "Незанятые задачи проверки",
  "proj.description": "Описание",
  "proj.published": "Опубликован",

  "editor.speakerDetails": "Данные спикеров",
  "editor.provideTranscription": "Введите транскрипцию",
  "editor.referenceTranscript": "Эталонная транскрипция",
  "editor.verbatim": "Дословная транскрипция",
  "editor.semanticL2": "Нормализованная (L2) транскрипция",
  "editor.selectSpeaker": "Выберите спикера",
  "editor.selectNoiseTag": "Метка шума",
  "editor.autosave": "Автосохранение включено.",
  "editor.regions": "Сегменты",
  "editor.labels": "Метки",
  "editor.relations": "Связи",
  "editor.noRegionSelected": "Сегмент не выбран",
  "editor.deleteSubtitle": "Удалить сегмент",
  "editor.add": "Добавить",
  "editor.update": "Сохранить",
  "editor.accept": "Принять",
  "editor.revise": "Вернуть",
  "editor.glossary": "Глоссарий",

  "ds.createNewInstance": "Новый датасет",
  "ds.instanceName": "Название датасета",
  "ds.instanceDescription": "Описание датасета",
  "ds.datasetType": "Тип датасета",
  "ds.confirm": "Подтвердить",
  "ds.selectFile": "Выберите файл",
  "ds.selectFileFormat": "Формат файла",
  "ds.upload": "Загрузить",

  "create.title": "Создание проекта",
  "create.titleField": "Название:",
  "create.descriptionField": "Описание:",
  "create.selectCategory": "Выберите категорию:",
  "create.finalize": "Завершить создание",
  "create.createProject": "Создать проект",
  // --- значения-перечисления (показ; в данных остаётся оригинал) ---
  "FULL_TIME": "Полная занятость",
  "PART_TIME": "Частичная занятость",
  "CONTRACT_BASIS": "По договору",
  "NA": "Не указано",

  // --- общие действия / кнопки ---
  "Required": "Обязательно",
  "Cancel": "Отмена",
  "Submit": "Отправить",
  "Confirm": "Подтвердить",
  "Confirm Selections": "Подтвердить выбор",
  "Save": "Сохранить",
  "Save task for later": "Сохранить как черновик",
  "Add": "Добавить",
  "Add New Item": "Добавить элемент",
  "Remove": "Удалить",
  "Delete": "Удалить",
  "Update": "Сохранить",
  "Updata": "Сохранить",
  "Close": "Закрыть",
  "Copy": "Копировать",
  "Copy Text": "Копировать текст",
  "Download": "Скачать",
  "Export": "Экспорт",
  "Import HTML Table": "Импорт HTML-таблицы",
  "Export HTML Table": "Экспорт HTML-таблицы",
  "Validate": "Подтвердить",
  "Reject": "Отклонить",
  "Approve": "Одобрить",
  "Resend": "Отправить повторно",
  "Change": "Изменить",
  "Edit Profile": "Редактировать профиль",
  "Update Profile": "Сохранить профиль",
  "View": "Открыть",
  "View Profile": "Открыть профиль",
  "Back": "Назад",
  "Reset": "Сбросить",
  "Apply": "Применить",
  "Search": "Поиск",
  "Filter Table": "Фильтр таблицы",
  "Filter Labels": "Фильтр меток",
  "Clear Selection": "Снять выделение",
  "Verify": "Подтвердить",
  "Verify Email": "Подтвердить email",
  "Send link": "Отправить ссылку",
  "Pin": "Закрепить",
  "Count": "Количество",
  "All": "Все",
  "None": "Нет",
  "More": "Ещё",
  "Type": "Тип",
  "Status": "Статус",
  "Action": "Действие",
  "Actions": "Действия",
  "Name": "Название",
  "Id": "ID",
  "Description": "Описание",
  "Title": "Название",
  "Domain": "Домен",
  "Language": "Язык",
  "Languages": "Языки",
  "Role": "Роль",
  "Email": "Email",
  "Phone": "Телефон",
  "Username": "Имя пользователя",
  "UserName": "Имя пользователя",
  "Password": "Пароль",
  "First Name": "Имя",
  "Last Name": "Фамилия",
  "Created By": "Создал",
  "Manager": "Менеджер",
  "Owner": "Владелец",
  "Details": "Подробнее",
  "Color": "Цвет",
  "Tag": "Метка",
  "Chip": "Чип",
  "Editable": "Редактируемо",
  "Disabled": "Отключено",
  "Available": "Доступен",
  "Unavailable": "Недоступен",
  "Active": "Активен",
  "Not Active": "Неактивен",
  "Active Status": "Статус активности",
  "Availability Status": "Статус доступности",

  // --- навигация / роли ---
  "Organization": "Организация",
  "Organization Settings": "Настройки организации",
  "Projects": "Проекты",
  "Project": "Проект",
  "Workspace": "Рабочее пространство",
  "Admin": "Админ",
  "Profile": "Профиль",
  "Settings": "Настройки",
  "Help": "Помощь",
  "Notifications": "Уведомления",
  "Annotator": "Аннотатор",
  "Annotators": "Аннотаторы",
  "Reviewer": "Проверяющий",
  "Reviewers": "Проверяющие",
  "Super Checker": "Суперпроверяющий",
  "Super Checkers": "Суперпроверяющие",
  "Managers": "Менеджеры",
  "Members": "Участники",
  "User Options": "Меню пользователя",
  "User Details": "Данные пользователя",
  "User Settings": "Настройки пользователя",
  "App Settings": "Настройки приложения",
  "App Information": "О приложении",
  "Signed in as": "Вы вошли как",
  "Feedback": "Обратная связь",

  // --- статусы / этапы ---
  "Annotation": "Разметка",
  "Review": "Проверка",
  "Supercheck": "Суперпроверка",
  "SuperCheck": "Суперпроверка",
  "Super Check": "Суперпроверка",
  "Annotation Stage": "Этап разметки",
  "Review Stage": "Этап проверки",
  "Super Check Stage": "Этап суперпроверки",
  "Super-Check Stage": "Этап суперпроверки",
  "All Stage": "Все этапы",
  "Reject": "Отклонить",
  "Validated No Changes": "Принято без изменений",
  "Validated with Changes": "Принято с изменениями",

  // --- задачи / проект ---
  "Tasks": "Задачи",
  "All Tasks": "Все задачи",
  "Task Count": "Число задач",
  "Task Details": "Данные задачи",
  "Task ID": "ID задачи",
  "Task Status :": "Статус задачи:",
  "Annotation Tasks": "Задачи разметки",
  "Review Tasks": "Задачи проверки",
  "Super Check Tasks": "Задачи суперпроверки",
  "Task Reviews": "Проверки задач",
  "Task Analytics": "Аналитика задач",
  "Tasks Dashboard": "Панель задач",
  "Unassigned Task": "Незанятая задача",
  "Unassigned Annotation Tasks": "Незанятые задачи разметки",
  "Unassigned Review Tasks": "Незанятые задачи проверки",
  "Unassigned Super Check Tasks": "Незанятые задачи суперпроверки",
  "Total Labeled Task": "Всего размечено задач",
  "Reviewed Task Count": "Проверено задач",
  "Pending Review Tasks": "Задачи на проверке",
  "Pending Supercheck Tasks": "Задачи на суперпроверке",
  "Review Completed Task": "Проверка завершена",
  "SuperCheck Completed Tasks": "Суперпроверка завершена",
  "Total Tasks Count": "Всего задач",
  "Total Annotated Tasks": "Всего размеченных задач",
  "Queued Tasks Status": "Статус очереди задач",
  "Queued Task Details": "Данные задачи из очереди",
  "No Queued Tasks to Display": "Нет задач в очереди",
  "Fetch Task Details": "Получить данные задачи",
  "Project Page": "Страница проекта",
  "Project ID": "ID проекта",
  "Project Id": "ID проекта",
  "Project Name": "Название проекта",
  "Project Title": "Название проекта",
  "Project Type": "Тип проекта",
  "Project Type:": "Тип проекта:",
  "Project Type :": "Тип проекта:",
  "Project Stage": "Этап проекта",
  "Project stage": "Этап проекта",
  "Project Stage:": "Этап проекта:",
  "Project Description": "Описание проекта",
  "Project Mode": "Режим проекта",
  "Project Settings": "Настройки проекта",
  "Project Analytics": "Аналитика проекта",
  "Project Report Type": "Тип отчёта проекта",
  "Project Reports": "Отчёты по проектам",
  "Project Task IDs:": "ID задач проекта:",
  "Project User Type:": "Роль в проекте:",
  "Project User Type :": "Роль в проекте:",
  "Archived Projects:": "Архивные проекты:",
  "Archived Projects :": "Архивные проекты:",
  "Target Language": "Язык",
  "Target language": "Язык",
  "Target Language:": "Язык:",
  "Source Language": "Исходный язык",
  "Source Language:": "Исходный язык:",
  "Output Language :": "Язык вывода:",
  "Workspace Id": "ID пространства",
  "Workspace Name": "Название пространства",
  "Workspace Name :": "Название пространства:",
  "Workspace Settings": "Настройки пространства",
  "Workspace 1": "Пространство 1",

  // --- кнопки проекта / пакеты ---
  "Add New Annotation Project": "Новый проект разметки",
  "Add New Collection Project": "Новый проект сбора",
  "Create a Project": "Создание проекта",
  "Create Project": "Создать проект",
  "Create new account": "Создать аккаунт",
  "Pull New Batch": "Взять пачку задач",
  "Pull New Data Items": "Загрузить новые данные",
  "Pull New Data Items from Source Dataset": "Загрузить новые элементы из исходного датасета",
  "Pull Size": "Размер пачки",
  "Pull Status:": "Статус выборки:",
  "De-allocate Tasks": "Освободить задачи",
  "Deallocate User Tasks": "Освободить задачи пользователя",
  "Deallocate by Task ID": "Освободить по ID задачи",
  "Deallocate by user ID": "Освободить по ID пользователя",
  "Delete Project Tasks": "Удалить задачи проекта",
  "Publish Project": "Опубликовать проект",
  "Publish this project to make it live": "Опубликовать проект, чтобы он стал активным",
  "Export Project into Dataset": "Экспортировать проект в датасет",
  "Export all annotated tasks into an output dataset": "Экспортировать все размеченные задачи в датасет",
  "Assign Managers": "Назначить менеджеров",
  "Add New Item": "Добавить элемент",
  "Start Labelling Now": "Начать разметку",
  "Start reviewing now": "Начать проверку",
  "Start validating now": "Начать суперпроверку",

  // --- фильтры ---
  "Pick Dates": "Выбрать даты",
  "Select Report Type :": "Тип отчёта:",
  "Report Type": "Тип отчёта",
  "Report Level": "Уровень отчёта",
  "Reports": "Отчёты",
  "Projects Filter": "Фильтр проектов",
  "Filter by Task Type": "Фильтр по типу задачи",
  "Filter by Annotator": "Фильтр по аннотатору",
  "Filter by Reviewer": "Фильтр по проверяющему",
  "Filter by SuperChecker": "Фильтр по суперпроверяющему",
  "Select Task Statuses": "Выберите статусы задач",
  "Select Annotation Status :": "Статус разметки:",
  "Select Review Status :": "Статус проверки:",
  "Select Super Check Status :": "Статус суперпроверки:",
  "Annotation Status:": "Статус разметки:",
  "Review Status:": "Статус проверки:",
  "Supercheck Status:": "Статус суперпроверки:",
  "Rejected:": "Отклонено:",
  "Select Report Type :": "Тип отчёта:",
  "Select user role": "Выберите роль",
  "Select Task Type": "Выберите тип задачи",
  "Assigned User:": "Назначенный пользователь:",
  "Select User:": "Выберите пользователя:",
  "Status": "Статус",

  // --- редактор транскрипции / субтитры ---
  "Back to Project": "Назад к проекту",
  "Draft": "Черновик",
  "Next": "Далее",
  "Skip": "Пропустить",
  "Skip to next task": "Перейти к следующей задаче",
  "Go to next task": "Следующая задача",
  "Submit task": "Отправить задачу",
  "Update": "Сохранить",
  "Accept": "Принять",
  "Revise": "На доработку",
  "Revise Annotation": "Вернуть на доработку",
  "Accept Annotation": "Принять разметку",
  "Review Notes": "Заметки проверки",
  "Annotation Notes": "Заметки разметки",
  "Super Checker Notes": "Заметки суперпроверки",
  "SuperChecker Notes": "Заметки суперпроверки",
  "Place your remarks here ...": "Оставьте комментарий…",
  "Place your remarks here...": "Оставьте комментарий…",
  "Notes": "Заметки",
  "Glossary": "Глоссарий",
  "Select Noise Tag": "Метка шума",
  "Select Tag": "Выберите метку",
  "Select Speaker": "Выберите спикера",
  "Subtitles": "Субтитры",
  "Add Subtitle Box": "Добавить сегмент",
  "Split Subtitle": "Разделить сегмент",
  "Delete Subtitle": "Удалить сегмент",
  "Subtitle Preview": "Предпросмотр сегмента",
  "Timeline Scale:": "Масштаб дорожки:",
  "Playback Speed:": "Скорость воспроизведения:",
  "Playback Speed": "Скорость воспроизведения",
  "Repeat Count:": "Повторы:",
  "Play Once": "Один раз",
  "Repeat 1x": "Повтор 1x",
  "Repeat 2x": "Повтор 2x",
  "Infinite": "Бесконечно",
  "Scale": "Масштаб",
  "Hotkeys": "Горячие клавиши",
  "Hotkeys Explorer": "Список горячих клавиш",
  "Font Size": "Размер шрифта",
  "Undo": "Отменить",
  "Redo": "Повторить",
  "RTL Typing": "Ввод справа налево",
  "Enable RTL-typing": "Ввод справа налево",
  "Pause when typing": "Пауза при вводе",
  "Advanced Settings": "Доп. настройки",
  "Color Schema set": "Цветовая схема",
  "Verbatim Transcription": "Дословная транскрипция",
  "Semantic (L2) Transcription": "Нормализованная (L2) транскрипция",
  "Standardised Transcription": "Стандартизованная транскрипция",
  "Auto-save enabled for this scenario.": "Автосохранение включено.",
  "Auto-save is enabled for this scenario.": "Автосохранение включено.",
  "Hide Additional Options": "Скрыть доп. опции",
  "Show Additional Options": "Показать доп. опции",
  "Loading task data...": "Загрузка задачи…",
  "Recognized Text": "Распознанный текст",

  // --- датасеты ---
  "Datasets": "Датасеты",
  "Dataset ID": "ID датасета",
  "Dataset Id": "ID датасета",
  "Dataset Name": "Название датасета",
  "Dataset Title": "Название датасета",
  "Dataset Type": "Тип датасета",
  "Dataset Type:": "Тип датасета:",
  "Dataset Type :": "Тип датасета:",
  "Datset Type": "Тип датасета",
  "Dataset Description": "Описание датасета",
  "Dataset Visibility:": "Видимость датасета:",
  "Dataset Visibility :": "Видимость датасета:",
  "Dataset Instance Id": "ID экземпляра датасета",
  "Dataset Instance :": "Экземпляр датасета:",
  "Create New Dataset Instance": "Новый датасет",
  "Automate Datasets": "Автоматизация датасетов",
  "Inter-Automate Datasets": "Меж-автоматизация датасетов",
  "Intra-Automate Datasets": "Внутр-автоматизация датасетов",
  "Upload Data": "Загрузить данные",
  "Upload": "Загрузить",
  "Select File :": "Выберите файл:",
  "Select File Format :": "Формат файла:",
  "Delete Duplicate Records :": "Удалить дубли:",
  "DataSet Settings": "Настройки датасета",
  "Deduplicate Data Items": "Удалить дубликаты",
  "Delete Data Item": "Удалить элемент данных",
  "Delete by Range": "Удалить по диапазону",
  "Delete by IDs": "Удалить по ID",
  "Start Data ID:": "Начальный ID:",
  "End Data ID:": "Конечный ID:",
  "Data IDs:": "ID данных:",
  "Download DataSet": "Скачать датасет",
  "Download Metadata": "Скачать метаданные",
  "Add New Dataset": "Новый датасет",
  "Select dataset type:": "Тип датасета:",
  "Select Field:": "Поле:",
  "Select Fields to Deduplicate": "Поля для дедупликации",
  "Instance ID :": "ID экземпляра:",
  "Description :": "Описание:",
  "Source dataset instance:": "Исходный датасет:",
  "Source dataset type:": "Тип исходного датасета:",
  "Target dataset type:": "Тип целевого датасета:",
  "Target dataset instance:": "Целевой датасет:",

  // --- создание проекта ---
  "Title:": "Название:",
  "Description:": "Описание:",
  "Select a Category to Work in:": "Выберите категорию:",
  "Select a Project Type:": "Выберите тип проекта:",
  "Finalize Project": "Завершить создание",
  "Variable Parameters": "Переменные параметры",
  "Variable Parameters:": "Переменные параметры:",
  "Sampling Parameters": "Параметры выборки",
  "Sampling Mode :": "Режим выборки:",
  "Select Sampling Type:": "Тип выборки:",
  "Sampling Percentage:": "Процент выборки:",
  "Batch Size  :": "Размер пачки:",
  "Batch Number  :": "Номер пачки:",
  "Enter Batch size:": "Размер пачки:",
  "Enter Batch Number:": "Номер пачки:",
  "Filter String :": "Строка фильтра:",
  "Filter String:": "Строка фильтра:",
  "Read-only Configurations": "Настройки (только чтение)",
  "Dataset Rows:": "Строки датасета:",
  "Select sources to fetch data from:": "Выберите источники данных:",
  "Annotators Per Task:": "Аннотаторов на задачу:",
  "Tasks per batch:": "Задач за раз (в пачке):",
  "Create Annotations Automatically:": "Создавать разметку автоматически:",
  "Acoustic Enabled Stage:": "Этап акустической нормализации:",
  "Max Pending Tasks Per User": "Макс. задач в работе на пользователя",
  "Tasks Pull Count Per Batch": "Задач в одной пачке",
  "Enter source language": "Исходный язык",
  "Change Sources": "Изменить источники",

  // --- отчёты / аналитика ---
  "Analytics": "Аналитика",
  "Analytics Type": "Тип аналитики",
  "Statistics": "Статистика",
  "Total Summary": "Итог",
  "High-Level Reports": "Сводные отчёты",
  "Detailed Reports": "Подробные отчёты",
  "Annotation Statistics": "Статистика разметки",
  "Meta-Info Statistics": "Статистика метаданных",
  "Complete Statistics": "Полная статистика",
  "Meta Analytics": "Мета-аналитика",
  "Advance Analytics": "Расширенная аналитика",
  "Performance Analytics": "Аналитика производительности",
  "Base period": "Базовый период",
  "Comparison Period": "Период сравнения",
  "Individual": "Отдельно",
  "Comparison": "Сравнение",
  "Cumulative": "Кумулятивно",
  "Daily": "Ежедневно",
  "Weekly": "Еженедельно",
  "Monthly": "Ежемесячно",
  "This Year": "Этот год",
  "Last Year": "Прошлый год",
  "Till Date": "На текущую дату",
  "Plot Range": "Диапазон графика",
  "Total Audio Hours": "Всего часов аудио",
  "Total Annotation Audio Hours": "Часов размеченного аудио",
  "Total Reviewed AudioHours": "Часов проверенного аудио",
  "Total Annotated Count": "Всего размечено",
  "Total Audio Files Annotated": "Размечено аудиофайлов",
  "Total quality/ reviewed audio files": "Проверенных аудиофайлов",
  "Users Reports": "Отчёты по пользователям",
  "Payment Reports": "Отчёты по оплате",
  "Download Report As PDF": "Скачать отчёт (PDF)",
  "Download Report As Image": "Скачать отчёт (изображение)",
  "Select Report Type :": "Тип отчёта:",

  // --- организация / воркспейс / пользователи ---
  "Workspaces": "Рабочие пространства",
  "Invites": "Приглашения",
  "Logs": "Журнал",
  "Add New Workspace": "Добавить рабочее пространство",
  "Add Members to Workspace": "Добавить участников в пространство",
  "Add Annotators to Workspace": "Добавить аннотаторов в пространство",
  "Add Users": "Добавить пользователей",
  "Add User": "Добавить пользователя",
  "Nickname": "Ник (отображаемое имя)",
  "Nickname hint": "Если оставить пустым — сгенерируется автоматически. Должен быть уникальным.",
  "Edit user": "Изменить пользователя",
  "Workspace Manager": "Менеджер пространства",
  "Add Users...": "Добавить пользователей…",
  "Select Users...": "Выберите пользователей…",
  "Select users to be added.": "Выберите пользователей для добавления.",
  "Invite Users to Organisation": "Пригласить пользователей в организацию",
  "Invite Users to Organization": "Пригласить пользователей в организацию",
  "Add Members to Dataset": "Добавить участников в датасет",
  "Add Annotators to Project": "Добавить аннотаторов в проект",
  "Add Reviewers to Project": "Добавить проверяющих в проект",
  "Add SuperChecker to Project": "Добавить суперпроверяющего в проект",
  "Invite new members to organization": "Пригласить участников в организацию",
  "Invited Users": "Приглашённые пользователи",
  "Invited By": "Пригласил",
  "Enter email ids of users to invite": "Введите email приглашаемых пользователей",
  "Email ids": "Email-адреса",
  "Manager Suggestions": "Предложенные менеджеры",
  "Edit Organization": "Редактировать организацию",
  "Organization Name...": "Название организации…",
  "Archive Workspace": "Архивировать пространство",
  "Public Analytics": "Публичная аналитика",
  "Enter workspace details": "Данные пространства",
  "Visit Workspaces": "К рабочим пространствам",
  "Preferred Workspaces": "Предпочитаемые пространства",
  "Participation Type": "Тип участия",
  "Participation Types": "Типы участия",
  "Full-time": "Полная занятость",
  "Part-time": "Частичная занятость",
  "Contract-Basis": "По договору",

  // --- профиль / пароль / логин ---
  "Change Password": "Сменить пароль",
  "Current Password": "Текущий пароль",
  "New Password": "Новый пароль",
  "Confirm Password": "Подтвердите пароль",
  "Enter Current Password": "Введите текущий пароль",
  "Re-enter your Password": "Повторите пароль",
  "Both password must match.": "Пароли должны совпадать.",
  "Forgot password?": "Забыли пароль?",
  "Confirm Forgot Password": "Подтвердите новый пароль",
  "New to CSI Annotator ?": "Впервые в CSI Annotator?",
  "Already have an account ?": "Уже есть аккаунт?",
  "Profile Details": "Данные профиля",
  "My Progress": "Мой прогресс",
  "View Progress": "Открыть прогресс",
  "Recent Tasks": "Недавние задачи",
  "Daily Mails": "Ежедневные письма",
  "Schedule": "Расписание",
  "Schedule Emails (Payment Reports)": "Расписание писем (отчёты по оплате)",
  "Day of Week": "День недели",
  "Day of Month": "День месяца",
  "Sunday": "Воскресенье",
  "Monday": "Понедельник",
  "Tuesday": "Вторник",
  "Wednesday": "Среда",
  "Thursday": "Четверг",
  "Friday": "Пятница",
  "Saturday": "Суббота",

  // --- уведомления ---
  "Mark as read": "Отметить прочитанным",
  "Mark as Read": "Отметить прочитанным",
  "Mark all as read": "Отметить все прочитанными",
  "Mark All as read": "Отметить все прочитанными",
  "Unread": "Непрочитанные",
  "No notifications found": "Уведомлений нет",
  "No notifications available": "Уведомлений нет",
  "No unread notifications": "Нет непрочитанных уведомлений",

  // --- разное / таблицы / прочее ---
  "Jump to Page:": "Перейти на страницу:",
  "No results": "Нет результатов",
  "No table data found": "Нет данных таблицы",
  "List": "Список",
  "Card": "Карточки",
  "List view": "Списком",
  "Card view": "Карточками",
  "View Columns": "Столбцы",
  "Drag to reorder column": "Перетащите для сортировки столбца",
  "Drag to reorder row": "Перетащите для сортировки строки",
  "Filter Table": "Фильтр таблицы",
  "Select Language:": "Язык:",
  "Select Language": "Выберите язык",
  "Enter text here...": "Введите текст…",
  "Loading....": "Загрузка…",
  "Please do not add notes if you are going to skip the task!": "Не добавляйте заметки, если собираетесь пропустить задачу!",
  "Fetch Annotation Details": "Получить данные разметки",
  "Annotation ID": "ID разметки",
  "Annotation Details": "Данные разметки",
  "Annotations": "Разметка",
  "Auto-copy L1 to L2": "Копировать L1 в L2",
  "Super Check Settings": "Настройки суперпроверки",
  "Super Check Revision Loop Count :": "Число кругов доработки суперпроверки:",
  "Populate Draft Data Json": "Заполнить черновые данные",
  "Populate Predictions from AI Model": "Заполнить предсказания ИИ-модели",
  "Download all project annotations as a file": "Скачать всю разметку проекта файлом",
  "Download project tasks as CSV, TSV, or JSON": "Скачать задачи проекта в CSV, TSV или JSON",
  "Download All Projects": "Скачать все проекты",
  "Navigate to the dataset used by this project": "Перейти к датасету проекта",
  "View Dataset": "Открыть датасет",
  "Navigate to the workspace that contains this project": "Перейти к пространству проекта",
  "View Workspace": "Открыть пространство",
  "Add Glossary": "Добавить в глоссарий",
  "Source Text": "Исходный текст",
  "Target Text": "Целевой текст",
  "Source": "Источник",
  "Target": "Цель",
  "Are you sure want to Deallocate User Tasks ?": "Точно освободить задачи пользователя?",
  // --- Отчёты / аналитика: заголовки столбцов ---
  "Annotation Report": "Отчёт по разметке",
  "Reviewer Report": "Отчёт проверяющего",
  "Super Checker Report": "Отчёт супер-проверяющего",
  "Reviewer Name": "Имя проверяющего",
  "Assigned": "Назначено",
  "Labeled": "Размечено",
  "Unlabeled": "Не размечено",
  "Skipped": "Пропущено",
  "Rejected Files": "Отклонённые файлы",
  "Reject File": "Отклонить файл",
  "File does not meet requirements": "Файл не соответствует требованиям",
  "Reject file hint manager": "Файл не соответствует требованиям? Укажите причину — файл будет сразу исключён из работы и не попадёт к аннотаторам. Он появится в разделе «Отклонённые файлы» со статусом «Исключены».",
  "Reject file hint": "Файл не соответствует требованиям? Укажите причину — он уйдёт на проверку менеджеру и покинет ваши задачи. Если менеджер не согласится, файл вернётся в общий пул.",
  "Wrong language": "Не тот язык",
  "Poor quality / noise": "Плохое качество / шум",
  "Empty recording": "Пустая запись",
  "Off topic": "Не по теме",
  "Duplicate": "Дубликат",
  "Other": "Другое",
  "Comment": "Комментарий",
  "Comment (required)": "Комментарий (обязательно)",
  "Awaiting decision": "Ожидают решения",
  "Excluded": "Исключённые",
  "Rejected files hint": "Файлы, которые аннотаторы отметили как не соответствующие требованиям. Подтвердите отклонение (файл исключается) или верните файл в общий пул.",
  "Total": "Всего",
  "File": "Файл",
  "Reason": "Причина",
  "Rejected by": "Отклонил",
  "When": "Когда",
  "Return to pool": "Вернуть в пул",
  "Network error": "Ошибка сети",
  "Network error while rejecting the file": "Ошибка сети при отклонении файла",
  "Reviewed": "Проверено",
  "UnReviewed": "Не проверено",
  "Accepted": "Принято",
  "Rejected": "Отклонено",
  "Accepted With Minor Changes": "Принято с мелкими правками",
  "Accepted With Major Changes": "Принято с крупными правками",
  "(Accepted/Reviewed) Percentage": "Доля принятых (принято/проверено)",
  "Annotated Tasks": "Размеченные задачи",
  "Reviewed Tasks": "Проверенные задачи",
  "SuperChecked Tasks": "Супер-проверенные задачи",
  "Submitted Tasks": "Отправленные задачи",
  "Annotation Tasks Assigned": "Назначено задач разметки",
  "No. of Annotators Assigned": "Кол-во назначенных разметчиков",
  "No .of Annotators Assigned": "Кол-во назначенных разметчиков",
  "Total Segments Duration": "Общая длительность сегментов",
  "Total Raw Audio Duration": "Общая длительность аудио",
  "Avg Segment Duration": "Средняя длительность сегмента",
  "Average Segments Per Task": "Среднее число сегментов на задачу",
  "Average Word Error Rate A/R": "Средний WER (разметчик/проверяющий)",
  "Average Word Error Rate R/S": "Средний WER (проверяющий/супер)",
  "Average Annotation Time (In Seconds)": "Среднее время разметки (сек.)",
  "Avg Annotation Time (sec)": "Среднее время разметки (сек.)",
  "Word Count": "Число слов",
  "Total Word Count": "Всего слов",
  "Raw Audio Duration": "Длительность аудио",
  "Segment Duration": "Длительность сегмента",
  "Not Null Segment Duration": "Ненулевая длительность сегмента",
  "Annotated Tasks Audio Duration": "Длительность аудио размеченных задач",
  "Annotated Tasks Segments Duration": "Длительность сегментов размеченных задач",
  "Annotated Tasks Word Count": "Число слов в размеченных задачах",
  "Reviewed Tasks Audio Duration": "Длительность аудио проверенных задач",
  "Reviewed Tasks Segments Duration": "Длительность сегментов проверенных задач",
  "Reviewed Tasks Word Count": "Число слов в проверенных задачах",
  "SuperChecked Tasks Audio Duration": "Длительность аудио супер-проверенных задач",
  "SuperChecked Tasks Segments Duration": "Длительность сегментов супер-проверенных задач",
  "SuperChecked Tasks Word Count": "Число слов в супер-проверенных задачах",
  "Exported Tasks Audio Duration": "Длительность аудио экспортированных задач",
  "Exported Tasks Segments Duration": "Длительность сегментов экспортированных задач",
  "Exported Tasks Word Count": "Число слов в экспортированных задачах",
  "Rejected Audio Duration": "Длительность аудио отклонённых",
  "Rejected Segments Duration": "Длительность сегментов отклонённых",
  "Rejected Word Count": "Число слов в отклонённых",
  "Annotator - Unassigned Tasks": "Разметчик — неназначенные задачи",
  "Reviewer - Unassigned Tasks": "Проверяющий — неназначенные задачи",
  "Superchecker - Unassigned Tasks": "Супер — неназначенные задачи",
  "Average Annotator VS Reviewer Word Error Rate": "Средний WER: разметчик и проверяющий",
  "Average Annotator VS Reviewer Character Edit Distance": "Ср. расстояние правок (симв.): разметчик и проверяющий",
  "Average Annotator VS Superchecker Word Error Rate": "Средний WER: разметчик и супер",
  "Average Annotator VS Superchecker Character Edit Distance": "Ср. расстояние правок (симв.): разметчик и супер",
  "Average Reviewer VS Superchecker Word Error Rate": "Средний WER: проверяющий и супер",
  "Average Reviewer VS Superchecker Character Edit Distance": "Ср. расстояние правок (симв.): проверяющий и супер",
  "Average Bleu Score Annotator Vs Reviewer": "Средний BLEU: разметчик и проверяющий",
  "Average Bleu Score Reviewer Vs Superchecker": "Средний BLEU: проверяющий и супер",
  "Average Rejection Count Annotator Vs Reviewer": "Ср. число отклонений: разметчик и проверяющий",
  "Average Rejection Count Reviewer Vs Superchecker": "Ср. число отклонений: проверяющий и супер",
  "Cumulative Word Error Rate Annotator Vs Reviewer": "Суммарный WER: разметчик и проверяющий",
  "Cumulative Word Error Rate Annotator Vs Superchecker": "Суммарный WER: разметчик и супер",
  "Cumulative Word Error Rate Reviewer Vs Superchecker": "Суммарный WER: проверяющий и супер",
  // --- Редактор разметки аудио ---
  "Task": "Задача",
  "Double-click on any segment in the audio waveform to play it in a loop": "Дважды кликните по сегменту на дорожке, чтобы проиграть его в цикле",

  // --- Таблица задач: столбцы, статусы, действия ---
  "Scenario": "Сценарий",
  "Audio Duration": "Длительность аудио",
  "Reference Raw Transcript": "Эталонная сырая расшифровка",
  "Annotator Email": "Эл. почта разметчика",
  "Speakers Json": "Спикеры (JSON)",
  "Machine Transcribed Json": "Машинная расшифровка (JSON)",
  "Audio Url": "Ссылка на аудио",
  "Annotate": "Разметить",
  "Edit": "Редактировать",
  "unlabeled": "не размечено",
  "labeled": "размечено",
  "skipped": "пропущено",
  "draft": "черновик",
  "unreviewed": "не проверено",
  "accepted": "принято",
  "to_be_revised": "на доработку",
  "accepted_with_minor_changes": "принято с мелкими правками",
  "accepted_with_major_changes": "принято с крупными правками",
  "unvalidated": "не валидировано",
  "validated": "валидировано",
  "validated_with_changes": "валидировано с правками",
  "rejected": "отклонено",
  "incomplete": "не завершено",
  "annotated": "размечено",
  "reviewed": "проверено",
  "exported": "экспортировано",
  "freezed": "заморожено",
  "super_checked": "супер-проверено",
  "Published": "Опубликован",
  "Archived": "В архиве",

  // --- Панель спикеров / шум сегмента ---
  "Speakers": "Спикеры",
  "Speaker Name": "Имя",
  "Add speaker": "Добавить спикера",
  "Delete speaker": "Удалить спикера",
  "Gender": "Пол",
  "Age": "Возраст",
  "Region": "Регион",
  "Noise": "Шум",
  "no noise": "нет",
  "low": "низкий",
  "medium": "средний",
  "high": "высокий",
  "male": "муж.",
  "female": "жен.",
  "unknown": "неизв.",

  // --- Метаданные записи ---
  "Recording metadata": "Метаданные записи",
  "Dialect": "Диалект",
  "Quality": "Качество",
  "not set": "не задано",
  "good": "хорошее",
  "average": "среднее",
  "poor": "плохое",
  "Usable": "Годна",
  "Yes": "Да",
  "No": "Нет",
  "Reject reason": "Причина брака",
  "Topic": "Тематика",
  "Recording date": "Дата записи",
  "Add first segment": "Добавить первый сегмент",
  "No segments yet — add one to start transcribing.": "Сегментов ещё нет — добавьте, чтобы начать транскрипцию.",
  "Recognize whole file (ASR)": "Распознать весь файл (ASR)",
  "Recognize segment (ASR)": "Распознать сегмент (ASR)",
  "Recognizing…": "Распознаю…",
  "Recognize whole file confirm":
    "Распознать весь файл заново? Текущая разметка будет заменена результатом ASR.",
  "ASR segment failed": "Не удалось распознать сегмент",
  "ASR whole file failed": "Обработка файла завершилась неудачно",
  "ASR returned no segments": "ASR не вернул сегментов",
  "ASR timeout": "Распознавание не завершилось за отведённое время",
  "ASR service busy":
    "ASR-сервис сейчас занят (идёт фоновая предразметка) или не ответил вовремя — попробуйте позже.",
  "My tasks total": "Мои задачи — всего",
  "Assigned not started": "Назначено (не начато)",
  "In progress draft": "В работе (черновик)",
  "Labeled by me": "Размечено",
  "Returned for revision": "На доработку",
  "min": "мин",
  "h": "ч",
  "To review": "К проверке",
  "Accepted": "Принято",
  "Sent for revision": "Отправлено на доработку",
  "To super check": "К суперпроверке",
  "Validated": "Подтверждено",
  "Rejected": "Отклонено",
  "My Progress": "Мой прогресс",
  "Progress of": "Прогресс:",
  "Updated at": "Обновлено",
  "Annotated at": "Размечено",
  "Created at": "Создано",
  "When task was last updated": "Когда задача последний раз обновлялась",
  "When task was assigned": "Когда задача была назначена",
  "When task was first annotated": "Когда задачу впервые разметили",
  "Not Authorised to View Details": "Недостаточно прав для просмотра",
  "Assign to user": "Назначить исполнителю",
  "Choose who gets the selected tasks": "Выберите, кому передать выбранные задачи",
  "Assign": "Назначить",
  "Submit for review": "Сдать на проверку",
  "Submit for review hint": "Отправить работу проверяющему",
  "Emotion": "Тон/эмоция",
  "neutral": "Нейтральный",
  "happy": "Радость",
  "sad": "Грусть",
  "angry": "Злость",
  "surprised": "Удивление",
  "fearful": "Страх",
  "disgusted": "Отвращение",
  "Split at cursor": "Разбить по курсору",
  "Place cursor in text to split": "Поставьте курсор в тексте, чтобы разбить",
  "Uploaded Date": "Загружено",
  "Annotated Date": "Сдано",
  "Reviewed Date": "Проверено",
  "Superchecked Date": "Супер-проверка",
  "Open": "Открыть",
  "Menu": "Меню",
  "Submitted": "Сдано",
  "Changes summary": "Сводка изменений",
  "Edit log": "Журнал правок",
  "No edits recorded": "Правок не зафиксировано",
  "changed": "изменено",
  "and": "и ещё",
  "Changed at this stage": "Изменено на этом этапе",
  "Submitted by annotator": "Сдано аннотатором",
  "Segment": "Сегмент",
  "verbatim text is empty": "не заполнен дословный текст",
  "normalized text is empty": "не заполнен нормализованный (L2) текст",
  "speaker is not selected": "не выбран спикер",
  "Error in saving annotation": "Не удалось сохранить разметку",
  "Please select dates upto Today": "Можно выбрать даты не позже сегодняшней",
  "Invalid Date Format": "Неверный формат даты",
  "Status timeline": "Лента статусов",
  "Task History": "История задачи",
  "Send for revision": "Отправить на доработку",
  "Choose who will rework the task": "Выберите, кто будет доделывать задачу",
  "Assignee": "Исполнитель",
  "current": "текущий",
  "To start": "В начало",
  "To end": "В конец",
  "Rewind": "Назад",
  "Forward": "Вперёд",
  "sec": "с",
  "Play": "Играть",
  "Pause": "Пауза",
  "Zoom in": "Увеличить масштаб",
  "Zoom out": "Уменьшить масштаб",
  "Important dates": "Важные даты",
  "Status history": "История статусов",
  "Uploaded date": "Загружено",
  "Modified date": "Изменено",
  "Sent for review date": "Отправлено на проверку",
  "Completed date": "Выполнено",
  "Sent for revision date": "Отправлено на доработку",
  "Last edited time": "Последнее изменение",
  "Super check completed date": "Суперпроверка завершена",
  "my.summary.title": "Моя выработка",
  "my.summary.period.today": "За сегодня",
  "my.summary.period.week": "За неделю",
  "my.summary.stage.annotation": "Разметка",
  "my.summary.stage.review": "Проверка",
  "my.summary.stage.supercheck": "Суперпроверка",
  "my.summary.tasks": "сдано задач",
  "my.summary.duration": "длительность аудио",
  "my.summary.segments": "сегментов",
  "my.summary.returned": "возвращено на доработку",
  "audio.upload.button": "Загрузить аудио",
  "audio.upload.title": "Загрузка аудиофайлов",
  "audio.upload.choose": "Выбрать файлы",
  "audio.upload.limits": "WAV, mp3, m4a. Не более 50 файлов за раз, до 100 МБ каждый.",
  "audio.upload.selected": "Выбрано",
  "audio.upload.domain": "Домен",
  "audio.upload.runLlm": "Прогнать через LLM",
  "audio.upload.runLlmHint": "Файл станет доступен аннотаторам только после предразметки.",
  "audio.upload.sending": "Передача файла",
  "audio.upload.start": "Загрузить",
  "audio.upload.done": "Загружено",
  "audio.upload.failed": "с ошибкой",
  "audio.upload.markup": "Файл разметки (CSV)",
  "audio.upload.markupHint": "Необязательно. Таблица с колонками audio и text: имя аудиофайла и черновой текст. Черновик сразу окажется в задаче у аннотатора — исправлять, а не набирать заново. Применяется и к уже загруженным файлам с теми же именами, поэтому аудио можно загружать частями, а разметку — одним файлом.",
  "audio.upload.markupRows": "строк",
  "audio.upload.markupEmpty": "пустых текстов",
  "audio.upload.markupCovered": "Выбранных аудио в разметке",
  "audio.upload.markupExisting": "Совпадений с уже загруженными",
  "audio.upload.markupNoLlm": "Для файлов из разметки ASR-предразметка не запускается — черновик берётся из файла.",
  "audio.upload.markupL2": "Скопировать черновик и в нормализованный слой (L2)",
  "audio.upload.markupRemove": "Убрать",
  "audio.upload.markupApplied": "Разметка применена",
  "audio.upload.markupNotFound": "строк без файла в датасете",
  "audio.upload.markupInWork": "уже в работе у аннотатора — не тронуто",
  "audio.upload.markupAmbiguous": "имя повторяется в датасете — не тронуто",
  "audio.upload.markupBusy": "идёт ASR-предразметка — не тронуто",
  "audio.preannotation.title": "Предразметка",
  "audio.preannotation.done": "готово",
  "audio.preannotation.inQueue": "в очереди",
  "audio.preannotation.failed": "ошибок",
  "audio.preannotation.retry": "Повторить",
  "log.hint": "Журнал фоновых операций с датасетом: загрузка данных и выгрузка проектов. Ход LLM-предразметки смотрите на вкладке «Датасеты».",
  "log.task.upload": "Загрузка данных в датасет",
  "log.task.exportNew": "Выгрузка проекта (новой записью)",
  "log.task.exportInPlace": "Выгрузка проекта (обновление записей)",
  "log.pre.title": "Журнал предразметки",
  "log.pre.hint": "Каждая попытка обработки отдельной строкой, включая повторы после сбоев.",
  "log.pre.file": "Файл",
  "log.pre.attempt": "Попытка",
  "log.pre.segments": "Сегментов",
  "log.pre.spent": "Обработка",
  "log.pre.started": "Начата",
  "log.pre.sec": "с",
  "log.pre.status.done": "Готово",
  "log.pre.status.failed": "Ошибка",
  "log.pre.status.running": "Обрабатывается",
  "col.audioUrl": "Ссылка на аудио",
  "col.speakerCount": "Число спикеров",
  "col.speakersJson": "Спикеры",
  "col.metadataJson": "Метаданные",
  "col.draftDataJson": "Черновик предразметки",
  "col.transcribedJson": "Транскрипция",
  "col.machineTranscribedJson": "Машинная транскрипция",
  "col.finalTranscribedJson": "Итоговая транскрипция",
  "col.predictionJson": "Предсказание модели",
  "col.preannotationStatus": "Статус предразметки",
  "col.preannotationError": "Ошибка предразметки",
  "col.preannotationFinishedAt": "Предразметка завершена",
  "col.originalFilename": "Исходное имя файла",
  "col.instanceId": "Датасет",
  "col.parentData": "Исходная запись",
  "col.preannotation.none": "Не требуется",
  "log.pre.status.pending": "В очереди",
  "table.showFull": "Открыть целиком",
  "stage.annotationOnly": "Только разметка",
  "stage.reviewEnabled": "Разметка и проверка",
  "stage.supercheckEnabled": "Разметка, проверка, супер-проверка",
  "proj.pullNewData": "Подтянуть новые данные",
  "Failed to pull new data items": "Не удалось подтянуть новые данные",
  "create.missing": "Чтобы создать проект, заполните",
  "Select Project Type:": "Тип проекта:",
  "Language:": "Язык:",
  "autoAnn.label": "Принять предразметку как готовую работу:",
  "autoAnn.none": "Нет — размечают люди",
  "autoAnn.annotation": "Закрыть этап разметки",
  "autoAnn.review": "Закрыть разметку и проверку",
  "autoAnn.supercheck": "Закрыть все этапы",
  "acoustic.label": "С какого этапа доступен нормализованный текст:",
  "acoustic.fromAnnotation": "С разметки",
  "acoustic.fromReview": "С проверки",
  "acoustic.fromSupercheck": "С супер-проверки",
  "project.notPublished": "Проект не опубликован — задачи созданы, но в работу не выдаются.",
  "project.publish": "Опубликовать",
  "project.publishFailed": "Не удалось опубликовать проект",
  "unassigned.tab": "Свободные задачи",
  "unassigned.hint": "Задачи, которые ещё никто не взял. Можно выдать конкретному исполнителю.",
  "unassigned.free": "Свободно",
  "unassigned.choosePerson": "Выберите исполнителя",
  "unassigned.assign": "Назначить",
  "unassigned.assignFailed": "Не удалось назначить задачи",
  "unassigned.stage.annotation": "На разметку",
  "unassigned.stage.review": "На проверку",
  "unassigned.stage.supercheck": "На супер-проверку",
  "Version": "Версия",
  "Frontend": "Фронт",
  "Backend": "Бэк",
};

export default ru;
